export default __webpack_public_path__ + "static/media/star.e2c03586.svg";